import React from 'react';
import { opacify } from '@ux/style-utils';
import { gu2px, Curvature, Colorway, useTheme } from '@uds/theme-utils';
import cssSides, { Side } from '@team-griffin/css-sides';
import { useStyles } from '@team-griffin/stylr';

interface OuterProps {
  colorway: Colorway;
  activeIndex: number;
  index: number;
  visibleItems: number;
  role: string;
}

const useStylesheet = ({ colorway, active }: { colorway: Colorway; active: boolean }) => {
  const {
    theme: { spacing, palette, curvature },
  } = useTheme();
  const getBorderRadius = (curvature: Curvature) => {
    if (curvature === Curvature.WEAK) {
      return 2;
    }
    if (curvature === Curvature.STRONG) {
      return gu2px(2, spacing);
    }
    return 0;
  };
  return useStyles(
    {
      default: {
        root: {
          display: 'block',
          height: gu2px(0.5, spacing),
          width: gu2px(3, spacing),
          ...cssSides('margin', Side.X, gu2px(0.5, spacing)),
          backgroundColor: opacify(palette.grey06, 0.5),
          transition: 'background-color 0.2s ease-in-out, height 0.2s ease-in-out',
          borderRadius: getBorderRadius(curvature),
        },
      },
      unsafeColorway: {
        root: {
          backgroundColor: opacify(palette.grey09, 0.5),
        },
      },
      active: {
        root: {
          backgroundColor: palette.secondary,
          height: gu2px(1, spacing),
        },
      },
    },
    [
      {
        unsafeColorway:
          [Colorway.PRIMARY, Colorway.DARK, Colorway.PRIMARY_GRADIENT, Colorway.HIGHLIGHT].indexOf(colorway) > -1,
      },
      { active },
    ],
  );
};

const PureSalesboardPaginationItem = ({ colorway, visibleItems, activeIndex, index }: OuterProps) => {
  const visible = visibleItems - 1; // others are 0 indexed

  // it's active if if it's the current index,
  // or it's between the activeIndex and the visibleLimit added together
  const active = index === activeIndex || (index >= activeIndex && index <= activeIndex + visible);

  const { styles } = useStylesheet({
    colorway,
    active,
  });
  return <span style={styles.root} aria-hidden="true" />;
};

PureSalesboardPaginationItem.displayName = 'SalesboardPaginationItem';

export default PureSalesboardPaginationItem;
